import z from 'zod';
import * as consts from '@/consts/max-character-counts';

export const projectDetailsFormValueSchema = z.object({
  name: z.string(),
  description: z.string().max(consts.PROJECT_DESCRIPTION).optional(),
  goal: z.number(),
  clientName: z.string(),
});
export type ProjectDetailsFormValue = z.infer<typeof projectDetailsFormValueSchema>;